import React from 'react';
import Tooltip from './Tooltip';

/** Время заказа. У заказа Flowwow со временем — не слот, а готовность «к 10:18»
 *  (начало окна курьера площадки минус 20 минут, deliver_from); «ближайшее время»
 *  площадки (order.is_asap) — та же готовность розовой плашкой с молнией.
 *  Своя доставка Flowwow — время, которое выбрал покупатель («10:00–10:30»).
 *  Остальные заказы — слот доставки; пустой — «—». */
export function isFlowwowTimed(order) {
  // Своя доставка Flowwow (delivery) — обычный слот, как у наших заказов: deliver_from там —
  // начало окна вручения, а не готовность к приезду курьера площадки
  return order?.source_platform === 'flowwow' && order?.delivery_type !== 'delivery' && !!order?.deliver_from;
}

// Своя доставка Flowwow: показываем время покупателя, а не наш слот (решение 09.10) —
// заказ стоит в слоте (delivery_time) и в него попадает, маршруты считаются по слоту
export function flowwowWindowText(order) {
  if (order?.source_platform !== 'flowwow' || order?.delivery_type !== 'delivery') return null;
  const f = order.deliver_from;
  const t = order.deliver_to;
  if (f && t) return `${f}–${t}`;
  if (f) return `с ${f}`;
  if (t) return `до ${t}`;
  return null;
}

export function slotText(order) {
  if (isFlowwowTimed(order)) return `${order.is_asap ? '⚡ ' : ''}к ${order.deliver_from}`;
  const win = flowwowWindowText(order);
  if (win) return `${order.is_asap ? '⚡ ' : ''}${win}`;
  const t = order?.delivery_time || '—';
  return order?.is_asap ? `⚡ ${t}` : t;
}

const READY_HINT = 'Заказ Flowwow: к этому времени собран и фото отправлено — за 20 минут до окна курьера площадки';
const ASAP_HINT = 'Срочно: покупатель выбрал на Flowwow «ближайшее время». ' + READY_HINT.replace('Заказ Flowwow: к', 'К');

function Bolt() {
  return (
    <svg viewBox="0 0 24 24" width="11" height="11" fill="currentColor" aria-hidden="true" style={{ flexShrink: 0 }}>
      <path d="M13 2 4 14h7l-1 8 9-12h-7z" />
    </svg>
  );
}

export default function SlotChip({ order, deliveryTime, style }) {
  if (isFlowwowTimed(order)) {
    const label = `к ${order.deliver_from}`;
    return order.is_asap
      ? <Tooltip text={ASAP_HINT}><span className="chip-asap" style={style}><Bolt />{label}</span></Tooltip>
      : <Tooltip text={READY_HINT}><span style={style}>{label}</span></Tooltip>;
  }
  const t = order ? order.delivery_time : deliveryTime;
  const asap = !!order?.is_asap;
  const win = flowwowWindowText(order);
  if (win) {
    return (
      <Tooltip text={`Время, которое выбрал покупатель на Flowwow. Заказ — в слоте ${t || '—'}`}>
        <span style={style}>
          {asap && <span className="chip-asap" style={{ marginRight: 6 }}><Bolt /></span>}
          {win}
        </span>
      </Tooltip>
    );
  }
  return (
    <span style={style}>
      {asap && <span className="chip-asap" style={{ marginRight: 6 }}><Bolt /></span>}
      {t || '—'}
    </span>
  );
}
